import React from "react";
import { getMediaUrl } from "../../../utils/api";
import "./MediaCarousel.css";
import "./EvtImagenesGaleriaModal.css";

export default function EvtImagenesGaleriaModal({
  open,
  images,
  index,
  onClose,
  onPrev,
  onNext,
  onSelectIndex,
}) {
  if (!open) return null;

  const list = Array.isArray(images) ? images : [];
  const safeIndex =
    list.length === 0 ? 0 : Math.min(Math.max(0, index), list.length - 1);
  const current = list[safeIndex];
  const multi = list.length > 1;
  const caption = String(current?.referencia_bibliografica ?? "").trim();

  return (
    <div
      className="evt-modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="evt-modal evt-modal--galeria"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="evt-modal-header">
          <button
            type="button"
            className="evt-modal-close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <div className="evt-modal-body evt-modal-body--galeria">
          <div className="evt-modal-galeria">
            <div className="evt-media-wrapper evt-modal-media-wrapper">
              {multi ? (
                <button
                  type="button"
                  className="evt-nav-btn left"
                  onClick={onPrev}
                  aria-label="Anterior"
                >
                  <i className="bi bi-chevron-left" aria-hidden />
                </button>
              ) : null}

              <div className="evt-modal-imgwrap">
                <img
                  src={getMediaUrl(current?.url)}
                  alt={caption || "Imagen asociada"}
                />
              </div>

              {multi ? (
                <button
                  type="button"
                  className="evt-nav-btn right"
                  onClick={onNext}
                  aria-label="Siguiente"
                >
                  <i className="bi bi-chevron-right" aria-hidden />
                </button>
              ) : null}
            </div>

            {caption ? (
              <p className="evt-modal-caption-block">{caption}</p>
            ) : null}

            {multi ? (
              <div
                className="evt-modal-indicadores"
                aria-label="Indicadores de imagen"
              >
                {list.map((_, i) => (
                  <span
                    key={i}
                    className={`evt-modal-dot ${i === safeIndex ? "active" : ""}`}
                    onClick={() => onSelectIndex(i)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") onSelectIndex(i);
                    }}
                    aria-label={`Ver imagen ${i + 1}`}
                  />
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
